<template>
  <div
    class="banner-info"
    :class="{
      'banner-info_img': imgUrl,
    }"
  >
    <div class="banner-info__title">{{ title }}</div>
    <div v-if="$slots.default" class="banner-info__content">
      <slot />
    </div>
    <div v-if="imgUrl" class="banner-info__img">
      <img :src="imgUrl" :alt="title">
    </div>
    <button
      class="rr-button rr-button_sm rr-button_clear banner-info__close"
      type="button"
      aria-label="Закрыть"
      @click="close"
    >
      <icon icon-name='close' w="18" h="18" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'BannerInfo',
  props: {
    title: String,
    content: String,
    imgUrl: String,
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.banner-info {
  position: relative;
  padding: 16px 48px 16px 24px;
  background: $color-primary-1;
  border-radius: 4px;

  &_img {
    padding-bottom: 0;
  }

  @media (min-width: breakpoint(md)) {
    padding: 20px 170px 20px 24px;
  }

  &__title {
    font-weight: $font-weight-semibold;
    @include text-lg;
    color: $color-primary;
  }

  &__content {
    margin-top: 8px;
    max-width: 705px;
    font-weight: 400;
    @include text-md;
    color: $color-black-85;
  }

  &__img {
    max-width: 220px;
    margin: 16px auto 0;

    @media (min-width: breakpoint(md)) {
      position: absolute;
      right: 0;
      bottom: 0;
      max-width: 174px;
      max-height: 100%;
      margin: 0;
    }

    img {
      display: block;
      max-width: 100%;
    }
  }

  &__close {
    position: absolute;
    top: 0;
    right: 0;
    background: none;
    border: none;
    width: 48px;
    height: 48px;

    @media (min-width: breakpoint(lg)) {
      width: 40px;
      height: 40px;
    }
  }
}
</style>
